import { _axios } from "../axios";
import { AxiosPromise } from 'axios';

const departmentsUri = '/departments';

/**
 * Gets all departments
 *
 * @returns {AxiosPromise<any>}
 */
export function getAllDepartments() {
    return _axios.get( `${departmentsUri}` );
}

/**
 * Gets a department including sub departments and products.
 *
 * @param departmentSlug string
 * @returns {AxiosPromise<any>}
 */
export function getDepartment( departmentSlug ) {
    return _axios.get( `${departmentsUri}/${departmentSlug}` )
}

/**
 * Get the products from a department
 *
 * @param departmentSlug string
 * @returns {AxiosPromise<any>}
 */
export function getDepartmentProducts( departmentSlug ) {
    return _axios.get( `${departmentsUri}/${departmentSlug}/products` );
}

/**
 * Exports a count sheet for a given department
 *
 * @param slug
 * @returns {AxiosPromise<any>}
 */
export function exportDepartmentCountSheet(slug) {
    return _axios.get( `${departmentsUri}/${slug}/export-products`)
}

/**
 *
 * @param departmentSlug
 * @param department
 * @returns {AxiosPromise<any>}
 */
export function updateDepartment( departmentSlug, department ) {
    return _axios.patch( `${departmentsUri}/${departmentSlug}`, department );
}

/**
 * Adds a new department
 *
 * @param department
 * @returns {AxiosPromise<any>}
 */
export function addDepartment( department ) {
    return _axios.post( `${departmentsUri}`, department);
}

/**
 * Removes a department
 *
 * @param departmentSlug
 * @returns {AxiosPromise<any>}
 */
export function removeDepartment( departmentSlug = '') {
    return _axios.delete(`${departmentsUri}/${departmentSlug}`);
}


